<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-spin :spinning="loading">
        <a-form :form="form">
          <a-form-item label="网站标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['title', { rules: [{ required: true, message: '请输入网站标题' }] }]"
              name="title"
              placeholder="请输入网站标题"
            />
          </a-form-item>
          <a-form-item label="关键词" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
            <a-textarea
              rows="4"
              name="keywords"
              placeholder="请输入网站关键词"
              v-decorator="['keywords', { rules: [{ required: true, message: '请输入网站关键词' }] }]"
            />
          </a-form-item>

          <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea
              rows="4"
              name="description"
              placeholder="请输入网站介绍"
              v-decorator="['description', { rules: [{ required: true, message: '请输入网站介绍' }] }]"
            />
          </a-form-item>
          <a-form-item label="版权信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea
              rows="4"
              name="copyright"
              placeholder="请输入网站介绍"
              v-decorator="['copyright', { rules: [{ required: true, message: '请输入版权信息' }] }]"
            />
          </a-form-item>
          <a-form-item label="公众号二维码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <img-upload
              name="wechat_logo"
              v-decorator="['wechat_logo', { rules: [{ required: true, message: '请上传LOGO' }] }]"
            />
          </a-form-item>
          <a-form-item label="联系地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['address']" name="address" placeholder="请输入联系地址" />
          </a-form-item>
          <a-form-item label="联系我们" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email']" name="email" placeholder="请输入联系邮箱" />
          </a-form-item>
          <a-form-item label="媒体合作" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email_media']" name="email_media" placeholder="请输入联系邮箱" />
          </a-form-item>
          <a-form-item label="反馈与建议" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email_support']" name="email_support" placeholder="请输入反馈与建议" />
          </a-form-item>
          <a-form-item label="资金捐赠" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email_money']" name="email_money" placeholder="请输入资金捐赠" />
          </a-form-item>
          <a-form-item label="项目捐赠" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email_project']" name="email_project" placeholder="请输入项目捐赠" />
          </a-form-item>
          <a-form-item label="项目孵化" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email_project_incubation']" name="email_project_incubation" placeholder="请输入项目孵化" />
          </a-form-item>
          <a-form-item label="法律顾问" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email_law']" name="email_law" placeholder="请输入法律顾问" />
          </a-form-item>
          <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
            <a-button :loading="formLoading" @click="handleOnSubmit()" type="primary">提交</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { ImgUpload, UEditor, GoBack } from '@/components'
import { form } from '@/mixins'
import { requestPut, requestGet } from '@/api/api'

import pick from 'lodash.pick'
const fields = [
    'title',
    'copyright',
    'keywords',
    'description',
    'address',
    'wechat_logo',
    'email_media',
    'weibo_logo',
    'email_support',
    'email_money',
    'email_project',
    'email_project_incubation',
    'email',
    'email_law'
]
const apiList = {
    getInfo: '/settings/'
}
export default {
    name: 'SiteSetting',
    mixins: [form],
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            fields,
            apiList
        }
    },
    mounted () {
        this.getData() // 获取编辑信息
    },
    methods: {
        /**
         * 获取编辑信息getItem
         * @id
         */
        getData () {
            this.loading = true
            requestGet('/settings')
                .then(res => {
                    this.form.setFieldsValue(pick(res.result, fields))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        handleOnSubmit () {
            const that = this
            that.form.validateFields((err, values) => {
                console.log(values)
                if (!err) {
                    that.formLoading = true // 表单加载
                    requestPut('/settings/update', values)
                        .then(res => {
                            that.$confirm({
                                title: res.msg,
                                okText: '继续编辑',
                                cancelText: '返回列表',
                                onOk () {

                                },
                                onCancel () {
                                    that.$router.go(-1)
                                }
                            })
                        })
                        .finally(() => {
                            that.formLoading = false // 执行完加载关闭
                        })
                }
            })
        }

    }
}
</script>
